import { FormField } from '@/components/ui/form';
import useSymbol from '@/hooks/use-symbol';
import { useCurrentAccount } from '@/store/use-account-store';
import { useMarketStore } from '@/store/use-markets-store';
import { MarketStatus } from '@/types';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useStore } from 'zustand';
import { OrderFormSchema } from '../order-form';
import { Tabs, TabsList, TabsTrigger } from '../order-tabs';

export default function SideTabs() {
  const { t } = useTranslation();
  const symbol = useSymbol();

  const form = useFormContext<OrderFormSchema>();

  const isReduceOnly = useStore(
    useMarketStore(symbol),
    (state) => state.marketSpec.status === MarketStatus.REDUCE_ONLY,
  );

  const isLong = useCurrentAccount((state) => {
    const position = state.positions[symbol];
    if (!position) return;
    return position.isLong;
  });

  const reduceOnly = form.watch('order.reduceOnly');

  useEffect(() => {
    if (isLong === undefined) return;
    if (reduceOnly) {
      form.setValue('order.isBuy', !isLong);
    }
  }, [isLong, reduceOnly]);

  return (
    <FormField
      control={form.control}
      name="order.isBuy"
      render={({ field }) => (
        <Tabs
          className="w-full"
          value={field.value.toString()}
          onValueChange={(value) => {
            const isBuy = value === 'true';
            if (reduceOnly && isLong === isBuy) {
              form.setValue('order.reduceOnly', false);
            }
            field.onChange(isBuy);
          }}
        >
          <TabsList className="grid grid-cols-2 border-y border-border md:border-t-0">
            <TabsTrigger
              disabled={isReduceOnly && isLong === true}
              value="true"
              className="border-r border-border hover:text-green disabled:hover:text-inherit data-[state=active]:!bg-green/5 data-[state=active]:text-green"
            >
              {t('orderForm.long')}
            </TabsTrigger>
            <TabsTrigger
              disabled={isReduceOnly && isLong === false}
              value="false"
              className="hover:text-red disabled:hover:text-inherit data-[state=active]:bg-red/5 data-[state=active]:text-red"
            >
              {t('orderForm.short')}
            </TabsTrigger>
          </TabsList>
        </Tabs>
      )}
    />
  );
}
